import React from 'react'

import {withStyles} from '@material-ui/core/styles/index'

import classNames from 'classnames'

import Avatar       from '@material-ui/core/Avatar'
import Button       from '@material-ui/core/Button'
import Icon         from '@material-ui/core/Icon'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import MenuItem     from '@material-ui/core/MenuItem'
import Popover      from '@material-ui/core/Popover'
import Typography   from '@material-ui/core/Typography'

import { Link , withRouter } from 'react-router-dom'

import FuseAnimate from '../../@fuse/components/FuseAnimate/FuseAnimate'

import DisplayObject from './DisplayObject'

import AuthStatus from "../net/auth/AuthStatus"
import logout     from "../net/auth/logout"

import i18n from "../locale"
import user from '../user'

const styles = theme =>
({
    root     :
    {
        display   : 'flex',
        alignItems: 'center',
        width     : '100%'
    },
    separator :
    {
        width          : 1,
        height         : 64,
        backgroundColor: theme.palette.divider
    }
});

class Toolbar extends DisplayObject
{
    constructor( props )
    {
        super( props ) ;

        this.change = this.change.bind(this) ;

        user.change.connect( this.change ) ;

        this.state =
        {
            ...this.state ,
            locale : i18n.fr,
            menu   : null
        };
    }

    get connected()
    {
        return user.stored && (AuthStatus.check() === AuthStatus.CONNECTED) ;
    }

    change()
    {
        if( this.mounted )
        {
            this.forceUpdate();
        }
    }

    close = () =>
    {
        this.setState( { menu: null } );
    };

    open = event =>
    {
        this.setState( { menu: event.currentTarget } );
    };

    render()
    {
        const { classes } = this.props ;
        return (
            <div className={classNames(classes.root, "flex flex-row")}>
                <div className="flex flex-1 px-24">
                    <Typography>Platform XYZ</Typography>
                </div>
                { this.renderOptions() }
            </div>
        );
    }

    renderOptions()
    {
        if( this.connected )
        {
            user.read();
            return (
                <div className="flex">
                    { this.renderProfile() }
                    { this.renderPopOver() }
                </div>
            );
        }
        else
        {
            return null ;
        }
    }

    renderPopOver()
    {
        const { menu , locale } = this.state ;
        return (
            <Popover
                open            = { Boolean(menu) }
                anchorEl        = { menu }
                onClose         = { this.close }
                anchorOrigin    = { { vertical  : 'bottom', horizontal: 'center' }}
                transformOrigin = { { vertical  : 'top'   , horizontal: 'center' }}
                classes         = { { paper     : "py-8" } }
            >
                <React.Fragment>
                    <MenuItem component={Link} to="/account/me" onClick={ this.close }>
                        <ListItemIcon><Icon>person</Icon></ListItemIcon>
                        <ListItemText className="pl-0" primary={locale.account.toolbar.about}/>
                    </MenuItem>
                    <MenuItem component={Link} to="/account/activities" onClick={ this.close }>
                        <ListItemIcon><Icon>line_weight</Icon></ListItemIcon>
                        <ListItemText className="pl-0" primary={locale.account.toolbar.activities}/>
                    </MenuItem>
                    <MenuItem component={Link} to="/account/sessions" onClick={ this.close }>
                        <ListItemIcon><Icon>cloud_circle</Icon></ListItemIcon>
                        <ListItemText className="pl-0" primary={locale.account.toolbar.sessions}/>
                    </MenuItem>
                    <MenuItem onClick={ () => { this.close(); logout(); }}>
                        <ListItemIcon><Icon>exit_to_app</Icon></ListItemIcon>
                        <ListItemText className="pl-0" primary={locale.account.toolbar.logout}/>
                    </MenuItem>
                </React.Fragment>
            </Popover>
        );
    }

    renderProfile()
    {
        let fullname = [] ;
        let initials = [] ;

        if( user.givenName )
        {
            fullname.push(user.givenName);
            initials.push(user.givenName.charAt(0));
        }

        if( user.familyName )
        {
            fullname.push( user.familyName ) ;
            initials.push( user.familyName.charAt(0)) ;
        }

        fullname = fullname.join(' ') ;
        initials = initials.join('') ;

        let team = '' ;
        try
        {
            if( user.team )
            {
                team = user.team.name ;
            }
        }
        catch( er )
        {

        }

        return (
            <FuseAnimate delay={300}>
                <Button className="h-64" onClick={ this.open } >
                    {
                        user.image
                            ? ( <Avatar className="" alt="user photo" src={user.image}/>  )
                            : ( <Avatar className="">{initials}</Avatar> )
                    }

                    <div className="hidden md:flex flex-col ml-12 items-start">
                        <Typography component="span" className="normal-case font-500 flex">
                            {fullname}
                        </Typography>
                        <Typography className="text-11 capitalize" color="textSecondary">
                            {team}
                        </Typography>
                    </div>
                    <Icon className="text-16 ml-12 hidden sm:flex" variant="action">keyboard_arrow_down</Icon>
                </Button>

            </FuseAnimate>
        );
    }
}

export default withStyles(styles, {withTheme: true})( withRouter(Toolbar) );



// WEBPACK FOOTER //
// ./src/app/display/Toolbar.js